import { Alert } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { CompetenciesTab } from '~/scenes/DevelopmentModule/components/Tabs/CompetenciesTab';
import { DevelopmentPlanTab } from '~/scenes/DevelopmentModule/components/Tabs/DevelopmentPlanTab';
import { EducationTab } from '~/scenes/DevelopmentModule/components/Tabs/EducationTab';
import { ExperienceTab } from '~/scenes/DevelopmentModule/components/Tabs/ExperienceTab';
import { JobReqEvaluationTab } from '~/scenes/DevelopmentModule/components/Tabs/JobReqEvaluationTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { EmployeeModuleTabs } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/components/EmployeeModuleTabs';
import { EmployeeModuleTabPath_Development } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/DevelopmentModule/data';
import { useEmployeeDevelopmentModule } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/DevelopmentModule/useEmployeeDevelopmentModule';

type PropsType = {
  hasFullAccess: boolean;
  modulePath: string;
};

export const EmployeeDevelopmentModule = (props: PropsType) => {
  const { hasFullAccess, modulePath } = props;

  const { isLoading, tabs, enabledTabPaths, defaultTab } =
    useEmployeeDevelopmentModule({
      hasFullAccess,
      modulePath,
    });

  const { t } = useTranslation();

  const renderTabContent = (tab: string) => {
    if (!enabledTabPaths.map((p) => p.toString()).includes(tab)) {
      return <Alert severity={'error'}>{t('laNoAuthorization')}</Alert>;
    }

    switch (tab) {
      case EmployeeModuleTabPath_Development.Experience:
        return <ExperienceTab />;
      case EmployeeModuleTabPath_Development.Education:
        return <EducationTab />;
      case EmployeeModuleTabPath_Development.Competencies:
        return <CompetenciesTab />;
      case EmployeeModuleTabPath_Development.DevelopmentPlan:
        return <DevelopmentPlanTab />;
      case EmployeeModuleTabPath_Development.JobReqEvaluation:
        return <JobReqEvaluationTab />;
      default:
        return <></>;
    }
  };

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <EmployeeModuleTabs
      defaultTab={defaultTab}
      enabledTabPaths={enabledTabPaths}
      tabs={tabs}
      render={(tab) => (
        <PortalErrorBoundary>{renderTabContent(tab)}</PortalErrorBoundary>
      )}
    />
  );
};
